import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_dining"}/>
}
